import React from 'react';
import { CSSTransition } from 'react-transition-group';
import cs from 'classnames';
import { useTranslation } from '@wix/wix-i18n-config';
import SearchCloseIcon from '../../../../Icons/Close.svg';
import { usePreventFocusOnClick } from '../../../hooks/usePreventFocusOnClick';
import s from './SearchClearButton.scss';

type SearchClearButtonProps = {
  isVisible: boolean;
  isSticky: boolean;
  dataHook: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const transitionTime = parseInt(s.transitionTime, 10);

export const SearchClearButton: React.FC<SearchClearButtonProps> = ({ isVisible, isSticky, dataHook, onClick }) => {
  const { t } = useTranslation();
  const preventFocusOnClick = usePreventFocusOnClick();

  return (
    <CSSTransition
      in={isVisible}
      classNames={{
        enter: s.buttonEnter,
        enterActive: s.buttonEnterActive,
        enterDone: s.buttonEnterDone,
        exitActive: s.buttonLeaveActive,
      }}
      timeout={{ enter: transitionTime, exit: transitionTime }}
      mountOnEnter
      unmountOnExit
    >
      <button
        onClick={onClick}
        type="button"
        className={cs(s.button, {
          [s.buttonLeave]: !isVisible,
          [s.largeInputClearButton]: !isSticky,
        })}
        aria-label={t('search.reset')}
        data-hook={dataHook}
        onFocus={preventFocusOnClick}
      >
        <SearchCloseIcon fill="currentColor" className={s.iconClear} />
      </button>
    </CSSTransition>
  );
};
